import React, { useState, useEffect } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import "./Compliance.css";

export default function CompliancePage({ openDefault = false }) {
  const today = new Date().toISOString().slice(0,10).replace(/-/g,'');
  const [open, setOpen] = useState(openDefault);
   useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  const heroStyle = {
    background: "url('/images/compliance-bg2.webp') center/cover no-repeat",
  };

  const events = [
    {
      title: "GST Filing",
      date: "20260410T053000Z/20260410T063000Z",
      details: "GST Return Filing",
    },
    {
      title: "TDS Payment",
      date: "20260407T053000Z/20260407T063000Z",
      details: "TDS Payment Due",
    },
    {
      title: "PF Filing",
      date: "20260425T053000Z/20260425T063000Z",
      details: "Provident Fund Filing",
    },
  ];

  const addEvent = (event) => {
    const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${event.title}&dates=${event.date}&details=${event.details}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {/* ===== SECTION 1 ===== */}
      <section className="compliance-hero" style={heroStyle}>
        <div className="overlay">
          <h1>
            Never miss your Business Compliance deadlines with <br />MPS Global.
          </h1>

          <p className="sub-text">
            We simplify legal and financial compliance so you stay focused on growing your business.
            <br />
            Easily integrate all compliance due dates with your Google Calendar in just one click.
          </p>

          {/* <p className="sub-text">
            Easily integrate all compliance due dates with your Google Calendar in just one click.
          </p> */}

        <button
  className="calendar-btn"
  onClick={() =>
    window.open(
      `https://calendar.google.com/calendar/embed?src=f927bac9e0d2a151ccbd5122dd91e75cd3dc301a8973d3b4d7b14a85e2688959@group.calendar.google.com&ctz=Asia%2FKolkata&dates=${today}/${today}`,
      "_blank"
    )
  }
>
  <FaCalendarAlt style={{ marginRight: "8px" }} />
  Add to your Calendar
</button>
          <p className="instruction">
            Click on "Add to your calendar" and sync all compliance dates instantly.
          </p>

          <div className="features">
            <div className="feature">
              <span>✔</span>
              <div>
                <h4>Easy Tracking</h4>
                <p>
                  Access all compliance due dates in one place. Never miss any important deadline.
                </p>
              </div>
            </div>

            <div className="feature">
              <span>✔</span>
              <div>
                <h4>Regular Updates</h4>
                <p>
                  Stay updated with the latest government changes automatically.
                </p>
              </div>
            </div>

            <div className="feature">
              <span>✔</span>
              <div>
                <h4>Email Reminders</h4>
                <p>
                  Get timely reminders before due dates and avoid penalties.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SECTION 2 ===== */}
      <section className="compliance-info">
      <h2>What you get</h2>

      <p className="compliance-desc">
        We provide complete compliance tracking for the following:
      </p>

      <div className="compliance-list">
        <span>» Tax Deducted at Source (TDS)</span>
        <span>» Employees State Insurance (ESI)</span>
        <span>» Provident Fund (PF)</span>
        <span>» Income Tax</span>
        <span>» ROC Filings</span>
        <span>» Professional Tax</span>
        <span>» Advance Tax</span>
        <span>» GST Filings &amp; Payments</span>
      </div>

      <h3>How to integrate it with your Google Calendar?</h3>

      <div className="calendar-steps">
        <p>
          - Click on the{" "}
          <a
            href="https://calendar.google.com/calendar/u/0/embed?src=f927bac9e0d2a151ccbd5122dd91e75cd3dc301a8973d3b4d7b14a85e2688959@group.calendar.google.com&ctz=Asia/Kolkata&dates=20260418/20260418"
            target="_blank"
            rel="noopener noreferrer"
            className="calendar-link"
          >
            "add to your calendar"
          </a>
          . Once you are on the Google Calendar page, add it to your account and
          sync the compliance due dates easily.
        </p>

        <p>- The next step is to enable the notifications.</p>

        <p className="sub-step">
          - Go to settings of the Google Calendar (top right).
        </p>

        <p className="sub-step">
          - Under "Settings for my calendars", click on Compliance Calendar.
        </p>

        <p className="sub-step">
          - Click "Add notification" under Event Notification.
        </p>

        <p className="sub-step">
          - The default notification can be set before the due date, or you can
          customize it according to your preference.
        </p>
      </div>
    </section>

      {/* ===== MODAL ===== */}
{open && (
  <div className="modal-overlay">

    <iframe
      src="https://calendar.google.com/calendar/embed?src=f927bac9e0d2a151ccbd5122dd91e75cd3dc301a8973d3b4d7b14a85e2688959@group.calendar.google.com&ctz=Asia%2FKolkata"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      title="calendar"
    ></iframe>

  </div>
)}
    </>
  );
}
